import { TickProps } from 'bold-ui/lib/components/Chart/Tick'
import React from 'react'

interface TickSemanaGestacionalProps extends TickProps {}

export function TickSemanaGestacional(props: TickSemanaGestacionalProps) {
  const {
    payload: { value },
    ...rest
  } = props

  return (
    <text dy={15} {...rest}>
      {value}
    </text>
  )
}
